/**
 * @architecture-header 1
 * @layer module
 * @domain authentication
 * @responsibility Validate sign-in credentials before invoking the host Supabase Auth adapter.
 * @state-owner React Hook Form consumers
 * @allowed-imports Zod
 * @forbidden components; API clients; host environment
 * @public-api auth module forms
 * @side-effects none
 * @tests module-contracts.test.ts
 * @security-boundary untrusted credential input validation
 * @data-classification credentials remain form-local and are never persisted
 * @trust-model validation improves UX; Supabase performs authentication
 */

import { z } from 'zod';

export const signInSchema = z.object({
  email: z.email('請輸入有效的 Email'),
});

export type SignInValues = z.infer<typeof signInSchema>;

export const emailCodeSchema = z.object({
  token: z.string().regex(/^\d{6}$/, '請輸入 Email 中的 6 位數登入碼'),
});

export type EmailCodeValues = z.infer<typeof emailCodeSchema>;
